module.exports = __webpack_public_path__ + "static/images/share5.2ab3a49.png";